<template>
    <div class="header-container">
        <div class="router-view">
            <el-breadcrumb
                separator="/">
                <el-breadcrumb-item
                    class="nav-item"
                    v-for="(item, index) in levelList"
                    :key="index">
                <!-- <span
                    @click="changeRouter(item.url, index)">
                    {{ item.meta[0].name }}
                </span> -->
                <span v-if="index === levelList.length - 1" class="current-path">{{ item.name }}</span>
                <a
                  class="pass-path"
                  v-else
                  @click="handleLink(item)">
                  {{ item.name }}
                </a>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="admin-right">
            <div class="img"></div>
            <el-dropdown
                @command="signOut"
                trigger="click">
                <span class="el-dropdown-link">
                {{ name }}
                <i class="el-icon-arrow-down el-icon--right"/>
                </span>
                <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                    <img
                    class="dk-icon-back">
                    退出
                </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
// import utils from '@/utils/index'
export default {
  data() {
    return {
      name: '',
      levelList: null
    }
  },
  watch: {
    $route(route) {
      this.getBreadcrumb()
    }
  },
  created() {
    this.name = this.$store.state.user.name ? this.$store.state.user.name : sessionStorage.getItem('userName')
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      if (this.$route.meta.length > 0) {
        this.levelList = this.$route.meta
        const { name } = this.$route
        if (name && !(this.$route.meta.some(item => item.noCache === true))) {
          this.$store.dispatch('global/addRouteName', this.$route)
        }
      }
    },
    changeRouter(url, index) {
      const { meta } = this.$route
      // 判断会议室管理会议服务管理路由跳转
      if (meta[meta.length - 1].url === 'funtion-add' || meta[meta.length - 1].url === 'funtion-set') {
        this.$router.push({ path: url, query: { select: false }})
      } else if (index === this.$route.meta.length - 1) return
      else this.$router.push({ path: url })
    },
    signOut() {
      this.$router.push({ path: '/login' })
    },
    handleLink(item) {
      if (item.url !== '') {
        this.$router.push({ path: item.url })
      }
      // if (item.meta && item.meta[0].url !== '') {
      //   this.$router.push({ path: item.meta[0].url })
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-item {
  cursor: pointer;
  user-select: none;
}
.header-container {
  padding: 0 57px 0 30px;
  height: 73px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #d4d1d1c7;
  margin: 0;
  .admin-right{
      height: 100%;
      display: flex;
      align-items: center;
      .img{
          background: #e3e393;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 15px;
      }
  }
}
.pass-path{
  color: #999;
}
.current-path{
  font-weight: bolder;
}
.el-dropdown-link{
  cursor: pointer;
}
</style>
